import "./AboutKTEX.module.css";
import Header from "@/reusable_sections/Header";
import Story from "./sections/Story";
import Leadership from "./sections/Leadership";
import Values from "./sections/Values";
import Footer from "@/reusable_sections/Footer";
import Whyktex from "./sections/Whyktex";
import WhoWeAre from "./sections/WhoWeAre";
export default function AboutKTEXPage() {
  return <div>
      <Header />
      <Story />
      <Whyktex />
      <WhoWeAre />
      <Leadership />
      <Values />
      <Footer />
    </div>;
}